<script setup>
import { formatearInputMoneda } from "@/utils/helpers";
import { computed, ref ,watch} from "vue";
import { useGarantiaStore } from "@/store/garantiaStore";
import { alertError, alertConfirmar } from "@/utils/alerts";

const props = defineProps({
    garantia_index:Number
})

const garantiaStore = useGarantiaStore();

const comprobante_garantia = computed(()=>{
   return garantiaStore?.comprobantes_aptos_devolucion[props.garantia_index] 
})

const tipoDevolucion = ref('total');    

const montoDevolucion = ref(null);

const montoMaximo = computed(() => {
  return Number(comprobante_garantia.value.monto_disponible);
  
});

watch(
  montoMaximo,
  (nuevo) => {
    if (nuevo > 0) montoDevolucion.value = nuevo;
    else montoDevolucion.value = null;
  },
  { immediate: true }
);

const es_devolucion_parcial = computed(() => {
  return tipoDevolucion.value === 'parcial'
})


function formatearNumero(event) {
  const soloDigitos = event.target.value.replace(/\D/g, "");
  const valor = soloDigitos ? Number(soloDigitos) : null;

  if (valor === null) {
    montoDevolucion.value = null;
    return;
  }

  const max = montoMaximo.value;
  montoDevolucion.value = Math.min(valor, max);
}

async function pedirDevolucion() {
  const max = montoMaximo.value;
  const monto = Number(montoDevolucion.value) || 0;

  if (monto <= 0) {
    alertError("El monto debe ser mayor a 0");
    return;
  }
  if (monto > max) {
    alertError("El monto supera el máximo posible");
    return;
  }


  const confirmada = garantiaStore.pedirDevolucion(comprobante_garantia.value.id, monto);
  
  if(confirmada) {
    alertConfirmar(
      "Se ha realizado el pedido de devolución. Debe esperar a ser aprobado."
    );
  }

}


</script>
<template>
  <tr class="text-xs text-center pe-5">
    <td>{{comprobante_garantia.id}}</td>
    <td>{{comprobante_garantia.banco_billetera}}</td>
    <td>{{comprobante_garantia?.medio_pago?.nombre }}</td>
    <td>${{formatearInputMoneda(comprobante_garantia.monto)}}</td>
    <td>${{formatearInputMoneda(comprobante_garantia.monto_disponible)}}</td>
    <td>
      <div class="d-flex flex-column align-items-start">
        <span><input :disabled="comprobante_garantia?.devolucion_solicitada && comprobante_garantia.monto_disponible === 0" type="radio" :name="'opcion_' + garantia_index" id="devolucion_total" autocomplete="off"  value='total' v-model="tipoDevolucion"> Total</span>
        <span v-if="comprobante_garantia?.medio_pago?.slug !== 'e-cheq'"><input :disabled="comprobante_garantia?.devolucion_solicitada && comprobante_garantia.monto_disponible === 0" type="radio" :name="'opcion_' + garantia_index" id="devolucion_parcial" autocomplete="off" value='parcial'  v-model="tipoDevolucion"> Parcial </span>
      </div>
    </td>
    <td>
      <input
        id="importe"
        type="text"
        class="form-control form-control-sm input-with-icon py-0 px-1"
        placeholder="$"
        :value="formatearInputMoneda(montoDevolucion ?? 0)"
        @input="formatearNumero"
        inputmode="numeric"
        pattern="\d*"
        :disabled="!es_devolucion_parcial"
      />
    </td>
    <td>
      <div class="d-flex flex-column">
        <button v-if="comprobante_garantia.monto_disponible>0"
            @click="pedirDevolucion"
            class="btn btn-outline-primary py-0 px-1"
        >
        Solicitar
        </button>
        <p><small v-if="comprobante_garantia.devolucion_solicitada">Pendiente</small></p>
      </div>
    </td>
  </tr>

</template>
<style lang="scss" scoped>
#importe {
  height: 24px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 1 !important;
}
</style>
